import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// API functions
export const authAPI = {
  register: (name, email, password) =>
    api.post('/auth/register', { name, email, password }),
  login: (email, password) => api.post('/auth/login', { email, password }),
  getMe: () => api.get('/auth/me')
};

export const enrollmentAPI = {
  create: (challengeId, paymentIntentId) =>
    api.post('/enrollments', { challenge_id: challengeId, payment_intent_id: paymentIntentId }),
  getAll: () => api.get('/enrollments')
};

export const paymentAPI = {
  createIntent: (challengeId, amount) =>
    api.post('/payments/create-intent', { challenge_id: challengeId, amount }),
  confirm: (paymentIntentId, challengeId) =>
    api.post('/payments/confirm', { payment_intent_id: paymentIntentId, challenge_id: challengeId })
};

export const contactAPI = {
  submit: (name, email, subject, message) =>
    api.post('/contact', { name, email, subject, message })
};

export default api;